// @ts-nocheck
// AppInsights.js
import React from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

// Prefer the Vite build-time env var; fall back to the runtime-injected value
// (window._env_, set by /env-config.js served by the .NET host in production).
const appInsightsConnectionString =
    import.meta.env.VITE_APPLICATION_INSIGHTS_CONNECTION_STRING ||
    (window._env_ && window._env_.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING);

var reactPlugin = new ReactPlugin();
var appInsights = new ApplicationInsights({
    config: {
        connectionString: appInsightsConnectionString,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: null }
        }
    }
});

if (appInsightsConnectionString) {
    appInsights.loadAppInsights();
}

export { appInsights, reactPlugin };
